/**
 * Descripción: Gestor de Rutas VUE-ROUTER
 *
 * @displayName index
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import paths from './path';
import BaseLocalHelper from '@/helpers/BaseLocalHelper';
import BaseNotificationsHelper from '@/helpers/BaseNotificationsHelper';

Vue.use(VueRouter);
const routes = [...paths];

const router = new VueRouter({
  mode: 'hash',
  routes
});

router.beforeEach((to, from, next) => {
  // redirect to login page if user is not logged in and trying to access a restricted page
  const publicPages = ['/authenticate', '/'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');
  const alert = localStorage.getItem('alert');

  let value = to.path != '/authenticate' ? to.path : '/';

  if (authRequired && !loggedIn) {
    if (alert) {
      BaseNotificationsHelper.Message(
        true,
        BaseLocalHelper.$_MsgUserSessionExpired
      );
    } else {
      value = '/';
    }
    localStorage.removeItem('alert');

    store.commit('authentication/CACHEROUTES', value, {
      root: true
    });
    return next('/authenticate');
  }

  next();
});

export default router;
